const Bar = ({ value, testid }) => (
  <div className="h-3 bg-slate-900 rounded-full overflow-hidden border border-amber-500/20 p-0.5" data-testid={testid}>
    <div className="h-full rounded-full bg-gradient-to-r from-amber-700 via-amber-400 to-amber-200 shadow-[0_0_12px_rgba(90,116,242,0.7)] transition-[width] duration-200"
      style={{ width: `${Math.min(100, value)}%` }} />
  </div>
);

const LABEL = { idle: "Oczekiwanie", checking: "Sprawdzanie", downloading: "Pobieranie aktualizacji", done: "Gotowe do gry", error: "Błąd" };

export default function PatchProgress({ state }) {
  return (
    <div className="space-y-3" data-testid="patch-progress">
      <div className="flex justify-between text-xs">
        <span className={state.phase === "error" ? "text-red-300" : "text-amber-200"} data-testid="patch-phase">{LABEL[state.phase]}</span>
        <span className="font-mono text-slate-400" data-testid="patch-total-percent">{Math.round(state.totalPercent)}%</span>
      </div>
      <div>
        <div className="flex justify-between text-[11px] text-slate-500 mb-1">
          <span className="truncate max-w-[75%] font-mono" data-testid="patch-current-file">{state.file || state.text || "-"}</span>
          <span className="font-mono">{Math.round(state.filePercent)}%</span>
        </div>
        <Bar value={state.filePercent} testid="patch-file-bar" />
      </div>
      <div>
        <div className="flex justify-between text-[11px] text-slate-500 mb-1">
          <span>Całość</span>
          <span className="font-mono" data-testid="patch-file-count">{state.done}/{state.total}</span>
        </div>
        <Bar value={state.totalPercent} testid="patch-total-bar" />
      </div>
      {state.phase === "error" && <p className="text-xs text-red-300" data-testid="patch-error">{state.error}</p>}
    </div>
  );
}
